import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  private readonly USER_DATA_KEY = 'user_data';
  private readonly region = 'es-ES';

  setUserData(data: any) {
    data.region = this.region;
    localStorage.setItem(this.USER_DATA_KEY, JSON.stringify(data));
  }

  getUserData(): any {
    const userData = localStorage.getItem(this.USER_DATA_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  clearUserData() {
    localStorage.removeItem(this.USER_DATA_KEY);
  }
}
